<template>
  <b-modal
    :visible="value"
    :title="title"
    size="xl"
    ok-only
    ok-title="Tutup"
    ok-variant="secondary"
    scrollable
    @change="$emit('input', $event)"
  >
    <div class="d-flex flex-column align-items-center justify-content-center border rounded bg-light p-5 text-center w-100" style="height: 1000px;">
      <i class="fa fa-file-pdf-o fa-3x text-muted mb-3" aria-hidden="true"></i>
      <h5>{{ title }}</h5>
      <p class="text-muted mb-0">Tampilan dummy. Dokumen PDF akan ditampilkan di sini.</p>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'DocumentPreviewModal',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Preview Dokumen',
    },
  },
}
</script>
